import { DsLanguageMap, DsDropshippingGuideI18nTemplate } from './dsTypes';

const OMS_SYSTEM_ORDER_RULE = 'https://oms.xlwms.com/system/orderRule/list';
const OMS_PLATFORM_ORDER_LIST = 'https://oms.xlwms.com/platform/order/list';
const OMS_WAREHOUSE_PACKET = 'https://oms.xlwms.com/warehouse/packet';
const OMS_WAREHOUSE_RETURN = 'https://oms.xlwms.com/warehouse/return';

export const dsOperationsTemplate: DsLanguageMap<DsDropshippingGuideI18nTemplate['operations']> = {
  zh: {
    lockedTitle: '处理日常业务',
    lockedDescription:
      '掌握完整的一件代发流程，包括自动和手动出库、订单处理、截单补发、退货处置等。支持主流电商平台自动拉单，订单自动流转，大幅提升运营效率。',
    lockedFeature1: '自动模式，订单自动流转',
    lockedFeature2: '手动模式，适应特殊场景',
    lockedFeature3: '完善的退货处置流程',
    lockedFeature4: '支持包装换标等增值服务',
    lockedActionOpenAccount: '立即开户',
    lockedActionContactSupport: '联系客服',
    cardDropshippingTitle: '一件代发',
    cardDropshippingDescription: '商品售出后，请新建出库单通知我们发货。',
    cardDropshippingNote:
      '一件代发出库后，OMS会将平台订单的物流跟踪号自动同步至电商平台，非平台面单的物流跟踪号无法同步。',
    sectionAutoModeTitle: '自动模式',
    sectionAutoModeDescription:
      '如果你的订单来自主流电商平台，且发货前无需审核，可以通过以下设置实现自动发货。',
    autoModeItems: [
      {
        title: '准备工作',
        subitems: [
          '确认[[店铺授权|/dropshipping/integration#section-shop-authorization]]已完成',
          '确认[[产品配对|/dropshipping/integration#section-product-mapping]]已完成或已实现自动配对',
        ],
      },
      {
        title: '进行自动化设置',
        subitems: [
          `在[[系统设置|${OMS_SYSTEM_ORDER_RULE}]]中新建平台订单规则`,
          '发货仓库：按需选择',
          '物流渠道：按需选择任意**海海快递**或**同步从电商平台购买的面单**',
          '自动审核：勾选',
        ],
      },
      {
        title: '跳过所有审核',
        subitems: [
          `在[[平台订单|${OMS_PLATFORM_ORDER_LIST}]]中勾选所有的**审核成功自动提交仓库**`,
          `在[[一件代发出库|${OMS_WAREHOUSE_PACKET}]]中勾选所有的**自动提交已获取面单和无需面单的出库单**`,
        ],
      },
      {
        title: '查看运行情况',
        subitems: [
          `定期在[[一件代发出库|${OMS_WAREHOUSE_PACKET}]]中查看是否存在异常订单`,
          '对照[[处理异常情况|/dropshipping/support]]处理异常订单',
        ],
      },
    ],
    sectionManualModeTitle: '手动模式',
    manualModeHaiHai: {
      title: '平台订单',
      description: '使用海海快递的面单',
      items: [
        {
          title: '分配仓库和物流',
          subitems: [
            `在[[平台订单|${OMS_PLATFORM_ORDER_LIST}]]的**待处理**中勾选需要发货的订单`,
            '点击**分配仓库&物流**',
            '发货仓库：按需选择',
            '物流渠道：选择**自动选取价格最低的渠道**或任意**海海快递**',
            '点击**确定并审核**',
          ],
        },
        {
          title: '提交出库单',
          subitems: [`在[[一件代发出库|${OMS_WAREHOUSE_PACKET}]]的**草稿-待获取面单**中提交出库单`],
        },
        {
          title: '等待获取海海面单',
          subitems: [`在[[一件代发出库|${OMS_WAREHOUSE_PACKET}]]的**草稿-获取中**中留意面单获取情况`],
        },
        {
          title: '确认并提交至仓库',
          subitems: [`获取成功后在[[一件代发出库|${OMS_WAREHOUSE_PACKET}]]的**草稿-待提交**中再次提交出库单`],
        },
      ],
    },
    manualModePlatform: {
      title: '平台订单',
      description: '使用从电商平台购买的面单',
      items: [
        {
          title: '分配仓库和物流',
          subitems: [
            `在[[平台订单|${OMS_PLATFORM_ORDER_LIST}]]的**待处理**中勾选需要发货的订单`,
            '点击**分配仓库&物流**',
            '发货仓库：按需选择',
            '物流渠道：选择**同步从电商平台购买的面单**',
            '点击**确定并审核**',
          ],
        },
        {
          title: '等待获取平台面单',
          subitems: [`在[[平台订单|${OMS_PLATFORM_ORDER_LIST}]]的**待获取平台面单**中留意面单获取情况`],
        },
        {
          title: '确认并提交至仓库',
          subitems: [`获取成功后在[[一件代发出库|${OMS_WAREHOUSE_PACKET}]]的**草稿-待提交**中提交出库单`],
        },
      ],
    },
    manualModeNonPlatform: {
      title: '非平台订单',
      description: '适用于补发或无法被OMS自动获取的平台面单',
      items: [
        {
          title: '新建出库单',
          subitems: [`在[[一件代发出库|${OMS_WAREHOUSE_PACKET}]]的**全部**中点击**新建**或**导入**`],
        },
        {
          title: '在出库单中填写发货信息',
          subitems: [
            '仓库：按需选择',
            '物流渠道：选择**自动选取价格最低的渠道**或任意**海海快递**',
            '收件信息：按需填写',
            '产品信息：按需选择',
          ],
        },
        {
          title: '等待获取海海面单',
          subitems: [`在[[一件代发出库|${OMS_WAREHOUSE_PACKET}]]的**草稿-获取中**中留意面单获取情况`],
        },
        {
          title: '确认并提交至仓库',
          subitems: [`获取成功后在[[一件代发出库|${OMS_WAREHOUSE_PACKET}]]的**草稿-待提交**中再次提交出库单`],
        },
      ],
    },
    cardSpecialOpsTitle: '一件代发的特殊操作',
    cardSpecialOpsDescription: '一件代发时，你可能会遇到一些特殊情况。',
    cardSpecialOpsNote:
      '截单或补发操作可能导致OMS中的库存与实际不符，我们会在操作完成后，按照实际情况进行调整。',
    sectionInterceptionTitle: '出库前截单',
    interceptionBlockTitle: '可以截单的情形',
    actionIntercept: '截单',
    interceptionItems: [
      {
        title: '库存不足',
        subitems: [
          '当实际库存不足以出库时，我们会询问你的意见，如果无法用其他商品代替，请操作截单。',
        ],
      },
      {
        title: '取消或修改入库单',
        subitems: ['当客户取消下单或入库单填写错误时，请操作截单，我们会尝试取消出库。'],
      },
      {
        title: '快递公司长时间未取件',
        subitems: [
          'UniUni、GOFO等新兴快递公司无实体网点，仅支持到仓取件。如果长时间未到仓，我们会询问你是否更换快递公司。如需更换，请操作截单，改用**海海快递USPS**等传统物流渠道补发。',
        ],
      },
    ],
    sectionReshipTitle: '出库后补发',
    reshipFree: {
      title: '可以免费补发的情形',
      description: '无法确定原面单已被使用时，可使用原面单进行补发。',
      actionPrimaryText: '联系海海客服',
      actionSecondaryText: '海海承诺',
      items: ['海外快递揽收后长时间无轨迹'],
    },
    reshipPaid: {
      title: '需要收费补发的情形',
      description: '原面单已被使用时，需重新新建出库单进行补发。',
      actionPrimaryText: '重新新建出库单',
      actionSecondaryText: '赔偿规则',
      items: ['海外仓错发', '海外快递丢件'],
    },
    cardReturnsTitle: '退货处置',
    cardReturnsDescription: '商品出库后，可能会出现以下2种退件情况。',
    cardReturnsNote:
      '退货处理费以退件单为计费依据，凡是已新建退件单的退货，无论最终是否上架，都会产生退货处理费。',
    sectionBuyerReturnsTitle: '买家退货',
    buyerReturnResellable: {
      title: '希望二次销售',
      description: '如果的认为退货有二次销售价值，请按以下流程进行操作。',
      items: [
        {
          title: '新建退件单',
          subitems: [`在[[退件|${OMS_WAREHOUSE_RETURN}]]中点击**新建**或**导入**`],
        },
        {
          title: '在退件单中填写退货信息',
          subitems: [
            '仓库：按需选择',
            '退件类型：选择**买家退件**',
            '退件包裹：添加包裹并填写**物流跟踪号**',
            '退件产品：添加**退件中的产品**并填写**对应的数量**',
          ],
        },
        {
          title: '确认处置方式',
          subitems: [
            '我们会在收到退货后拍照并向你征求处置意见',
            '可以二次销售：请答复**上架**',
            '无法二次销售：请答复**销毁**',
          ],
        },
        {
          title: '查看处置结果',
          subitems: [`在[[退件|${OMS_WAREHOUSE_RETURN}]]的**已处理**中查看最终处置结果`],
        },
      ],
    },
    buyerReturnNoResaleTitle: '无需二次销售',
    buyerReturnNoResaleDescription:
      '如果你认为退货的价值低于退货处理费，或无需查验即可直接销毁，则无需提交退件单，也无需向我们知会。我们收到退货后会直接销毁，过程中不产生任何费用。',
    sectionCarrierReturnsTitle: '快递退件',
    carrierReturnsDescription:
      '当出库的商品因地址错误等原因被快递公司退回时，我们会询问你是否希望进行二次销售，并按照买家退货的流程进行后续处置。',
    cardClearanceTitle: '滞销处置',
    proactiveClearanceTitle: '主动移仓或销毁',
    proactiveClearanceDescription:
      '如果商品出现滞销，为避免持续产生仓储费用，你可以向海海客服申请批量移仓或销毁。',
    forcedClearanceTitle: '强制销毁',
    forcedClearanceDescription:
      '如果出现以下任意情况，我们可能会单方面销毁你的商品，并扣除对应的滞销处理费。',
    forcedClearanceItems: ['监管部门要求销毁', '账户欠费超过30天且无法与你取得联系'],
    cardNonStandardTitle: '其他非标准化业务',
    nonStandardScopeTitle: '非标准化业务范围',
    nonStandardScopeDescription:
      '海外仓在入库、出库阶段，只执行入库单、出库单、退件单中列明的标准化操作，我们会在非核心时段集中处理以下特殊需求，并收取相应费用。',
    nonStandardScopeItems: [
      '商品包装',
      '商品换标',
      '商品清点',
      '商品维保',
      '更换商品说明书',
      '更换商品零部件',
    ],
    actionContactHaiHai: '联系海海客服',
    actionHaiHaiCommitments: '海海承诺',
    actionRecreateOutbound: '重新新建出库单',
    actionCompensationRules: '赔偿规则',
  },
  en: {
    lockedTitle: 'Handle daily operations',
    lockedDescription:
      'Master the full dropshipping workflow, including auto/manual outbound, order processing, interception and reshipment, and return handling. Supports automatic order pulling from mainstream e-commerce platforms for higher operational efficiency.',
    lockedFeature1: 'Auto mode with automatic order flow',
    lockedFeature2: 'Manual mode for special scenarios',
    lockedFeature3: 'Complete return-handling workflow',
    lockedFeature4: 'Supports value-added services such as packaging and relabeling',
    lockedActionOpenAccount: 'Open account',
    lockedActionContactSupport: 'Contact support',
    cardDropshippingTitle: 'Dropshipping',
    cardDropshippingDescription: 'After products are sold, create an outbound order to notify us for fulfillment.',
    cardDropshippingNote:
      'After dropshipping outbound, OMS automatically syncs tracking numbers to e-commerce platforms for platform labels. Non-platform label tracking cannot be synced.',
    sectionAutoModeTitle: 'Auto mode',
    sectionAutoModeDescription:
      'If your orders come from major e-commerce platforms and do not require pre-shipment review, use the setup below for automated fulfillment.',
    autoModeItems: [
      {
        title: 'Preparation',
        subitems: [
          'Confirm [[Store authorization|/dropshipping/integration#section-shop-authorization]] is completed',
          'Confirm [[Product mapping|/dropshipping/integration#section-product-mapping]] is completed or auto-mapping is enabled',
        ],
      },
      {
        title: 'Configure automation',
        subitems: [
          `Create platform order rules in [[System settings|${OMS_SYSTEM_ORDER_RULE}]]`,
          'Shipping warehouse: choose as needed',
          'Logistics channel: choose any **HaiHai courier** or **sync labels purchased on e-commerce platforms**',
          'Auto review: enabled',
        ],
      },
      {
        title: 'Skip all reviews',
        subitems: [
          `Enable **auto-submit reviewed orders to warehouse** in [[Platform orders|${OMS_PLATFORM_ORDER_LIST}]]`,
          `Enable **auto-submit outbound orders with labels acquired or no label required** in [[Dropshipping outbound|${OMS_WAREHOUSE_PACKET}]]`,
        ],
      },
      {
        title: 'Monitor operations',
        subitems: [
          `Regularly check [[Dropshipping outbound|${OMS_WAREHOUSE_PACKET}]] for exception orders`,
          'Handle exception orders based on [[Exception handling|/dropshipping/support]]',
        ],
      },
    ],
    sectionManualModeTitle: 'Manual mode',
    manualModeHaiHai: {
      title: 'Platform orders',
      description: 'Use HaiHai courier labels',
      items: [
        {
          title: 'Assign warehouse and logistics',
          subitems: [
            `Select orders to ship in **Pending** of [[Platform orders|${OMS_PLATFORM_ORDER_LIST}]]`,
            'Click **Assign warehouse & logistics**',
            'Shipping warehouse: choose as needed',
            'Logistics channel: choose **auto-select lowest-cost channel** or any **HaiHai courier**',
            'Click **Confirm and review**',
          ],
        },
        {
          title: 'Submit outbound order',
          subitems: [`Submit outbound orders from **Draft - pending label acquisition** in [[Dropshipping outbound|${OMS_WAREHOUSE_PACKET}]]`],
        },
        {
          title: 'Wait for HaiHai label acquisition',
          subitems: [`Track label acquisition status in **Draft - acquiring** of [[Dropshipping outbound|${OMS_WAREHOUSE_PACKET}]]`],
        },
        {
          title: 'Confirm and submit to warehouse',
          subitems: [`After successful label acquisition, resubmit from **Draft - pending submit** in [[Dropshipping outbound|${OMS_WAREHOUSE_PACKET}]]`],
        },
      ],
    },
    manualModePlatform: {
      title: 'Platform orders',
      description: 'Use labels purchased on e-commerce platforms',
      items: [
        {
          title: 'Assign warehouse and logistics',
          subitems: [
            `Select orders to ship in **Pending** of [[Platform orders|${OMS_PLATFORM_ORDER_LIST}]]`,
            'Click **Assign warehouse & logistics**',
            'Shipping warehouse: choose as needed',
            'Logistics channel: choose **Sync labels purchased on e-commerce platforms**',
            'Click **Confirm and review**',
          ],
        },
        {
          title: 'Wait for platform label acquisition',
          subitems: [`Track label acquisition in **Pending platform label** of [[Platform orders|${OMS_PLATFORM_ORDER_LIST}]]`],
        },
        {
          title: 'Confirm and submit to warehouse',
          subitems: [`After successful acquisition, submit from **Draft - pending submit** in [[Dropshipping outbound|${OMS_WAREHOUSE_PACKET}]]`],
        },
      ],
    },
    manualModeNonPlatform: {
      title: 'Non-platform orders',
      description: 'For reshipments or platform labels that OMS cannot fetch automatically',
      items: [
        {
          title: 'Create outbound order',
          subitems: [`In **All** of [[Dropshipping outbound|${OMS_WAREHOUSE_PACKET}]], click **Create** or **Import**`],
        },
        {
          title: 'Fill shipping details in outbound order',
          subitems: [
            'Warehouse: choose as needed',
            'Logistics channel: choose **auto-select lowest-cost channel** or any **HaiHai courier**',
            'Recipient info: fill as needed',
            'Product info: select as needed',
          ],
        },
        {
          title: 'Wait for HaiHai label acquisition',
          subitems: [`Track label acquisition in **Draft - acquiring** of [[Dropshipping outbound|${OMS_WAREHOUSE_PACKET}]]`],
        },
        {
          title: 'Confirm and submit to warehouse',
          subitems: [`After successful label acquisition, resubmit from **Draft - pending submit** in [[Dropshipping outbound|${OMS_WAREHOUSE_PACKET}]]`],
        },
      ],
    },
    cardSpecialOpsTitle: 'Special operations for dropshipping',
    cardSpecialOpsDescription: 'You may encounter special cases during dropshipping.',
    cardSpecialOpsNote:
      'Interception or reshipment may temporarily mismatch OMS inventory and actual stock. We will adjust inventory based on final actual results.',
    sectionInterceptionTitle: 'Intercept before outbound',
    interceptionBlockTitle: 'Scenarios eligible for interception',
    actionIntercept: 'Intercept',
    interceptionItems: [
      {
        title: 'Insufficient inventory',
        subitems: [
          'If actual inventory is insufficient for outbound, we will ask for your decision. If no substitute product is available, perform interception.',
        ],
      },
      {
        title: 'Cancel or modify outbound order',
        subitems: ['If the buyer cancels or outbound info is incorrect, perform interception and we will try to cancel outbound.'],
      },
      {
        title: 'Courier has not picked up for a long time',
        subitems: [
          'New couriers such as UniUni and GOFO often have no physical branches and only support warehouse pickup. If pickup is delayed too long, we will ask whether to switch couriers. If switching is needed, intercept and reship using traditional channels such as **HaiHai USPS**.',
        ],
      },
    ],
    sectionReshipTitle: 'Reship after outbound',
    reshipFree: {
      title: 'Scenarios eligible for free reshipment',
      description: 'If it is unclear whether the original label has been used, you can reship with the original label.',
      actionPrimaryText: 'Contact HaiHai support',
      actionSecondaryText: 'HaiHai commitments',
      items: ['No tracking for a long time after courier pickup'],
    },
    reshipPaid: {
      title: 'Scenarios requiring paid reshipment',
      description: 'If the original label has already been used, create a new outbound order for reshipment.',
      actionPrimaryText: 'Create new outbound order',
      actionSecondaryText: 'Compensation rules',
      items: ['Wrong shipment by overseas warehouse', 'Lost last-mile package'],
    },
    cardReturnsTitle: 'Return handling',
    cardReturnsDescription: 'After outbound, two return scenarios may occur.',
    cardReturnsNote:
      'Return handling fees are charged based on return orders. Any return with a created return order incurs handling fees, regardless of whether it is eventually shelved.',
    sectionBuyerReturnsTitle: 'Buyer returns',
    buyerReturnResellable: {
      title: 'Resellable returns',
      description: 'If you believe returned goods still have resale value, follow the process below.',
      items: [
        {
          title: 'Create return order',
          subitems: [`In [[Returns|${OMS_WAREHOUSE_RETURN}]], click **Create** or **Import**`],
        },
        {
          title: 'Fill return details in return order',
          subitems: [
            'Warehouse: choose as needed',
            'Return type: select **Buyer return**',
            'Return package: add package and enter **tracking number**',
            'Return products: add **returned items** and fill **quantities**',
          ],
        },
        {
          title: 'Confirm disposal method',
          subitems: [
            'After receiving returns, we will take photos and ask your disposal decision',
            'Resellable: reply **Shelve**',
            'Not resellable: reply **Destroy**',
          ],
        },
        {
          title: 'View disposal result',
          subitems: [`Check final results in **Processed** of [[Returns|${OMS_WAREHOUSE_RETURN}]]`],
        },
      ],
    },
    buyerReturnNoResaleTitle: 'No resale needed',
    buyerReturnNoResaleDescription:
      'If return value is lower than handling fees, or direct destruction is acceptable without inspection, you do not need to submit a return order or notify us. We will directly destroy the returned goods without additional handling fees.',
    sectionCarrierReturnsTitle: 'Carrier returns',
    carrierReturnsDescription:
      'When outbound goods are returned by the courier due to address issues or similar reasons, we will ask whether you want resale handling and follow the buyer-return workflow.',
    cardClearanceTitle: 'Slow-moving inventory handling',
    proactiveClearanceTitle: 'Proactive transfer or destruction',
    proactiveClearanceDescription:
      'If products become slow-moving, you can request batch transfer or destruction via HaiHai support to avoid ongoing storage fees.',
    forcedClearanceTitle: 'Forced destruction',
    forcedClearanceDescription:
      'If any of the following occurs, we may unilaterally destroy your goods and charge the corresponding handling fee.',
    forcedClearanceItems: [
      'Destruction required by regulators',
      'Account overdue for over 30 days and we cannot reach you',
    ],
    cardNonStandardTitle: 'Other non-standard services',
    nonStandardScopeTitle: 'Scope of non-standard services',
    nonStandardScopeDescription:
      'During inbound and outbound stages, overseas warehouses only perform standard operations listed in inbound/outbound/return orders. The following special requests are handled in non-core hours with additional fees.',
    nonStandardScopeItems: [
      'Product packaging',
      'Product relabeling',
      'Product counting',
      'Product maintenance',
      'Replace product manual',
      'Replace product components',
    ],
    actionContactHaiHai: 'Contact HaiHai support',
    actionHaiHaiCommitments: 'HaiHai commitments',
    actionRecreateOutbound: 'Create new outbound order',
    actionCompensationRules: 'Compensation rules',
  },
};
